export default __webpack_public_path__ + "group-profile-users.png";